import React, { useMemo } from "react";
import { IBemPrefixedElementContainer } from "@ngd-web/lv-utils/ui/bemHelper";

export const BemContext = React.createContext<IBemPrefixedElementContainer>(
    null
);

export function BemContextComponent({ children, el, bl = null }) {
    return (
        <BemContext.Provider value={useMemo(() => ({ el, bl }), [el])}>
            {children}
        </BemContext.Provider>
    );
}
